import { useEffect, useContext } from 'react'
import './styles.scss'
import { Row, Col, Form, Input, Checkbox, notification } from 'antd'
import { useTranslation } from 'react-i18next'

import { useNavigate } from 'react-router-dom'
import AlertComponent from '@BUP/components/Generics/Alert'
import ButtonComponent from '@BUP/components/Generics/Button'
import { ModeBupContext } from '@BUP/contexts/ModeBupContext'
import { useSendMessage } from '@BUP/hooks/ModoBup/useSendMessage'

const SendMessageForm = () => {
  const [form] = Form.useForm()

  const { handleSendMessage, response, errorResponse } = useSendMessage()
  const [t] = useTranslation()
  const navigate = useNavigate()
  const { checkboxState, onChangeCheckBox } = useContext(ModeBupContext)

  const onSubmit = async values => {
    const comment = {
      content: values.message || '',
      anonymus: values.anonymus ?? checkboxState
    }

    await handleSendMessage(comment)
  }

  useEffect(() => {
    document.getElementById('textArea').focus()
  }, [])

  useEffect(() => {
    if (response && response.id && !errorResponse) {
      navigate('/modebup/inbox')
      notification.info({
        style: { fontWeight: 500, fontSize: 17 },
        message: t('pages.modeBup.send.sendMessageformComponent.notificationMessage'),
        description: t('pages.modeBup.send.sendMessageformComponent.notificationDescription'),
        duration: 20
      })
    }
  }, [response, errorResponse, navigate, t])

  return (
    <Col
      xs={24}
      lg={18}
      xxl={18}
      className='send-message-form-container'
    >
      <h1>{t('pages.modeBup.send.sendMessageformComponent.formTitle')}</h1>
      <h2>{t('pages.modeBup.send.sendMessageformComponent.formText')}</h2>
      <Row style={{ marginTop: 20 }}>
        {/* // TODO : eliminar ternarios */}
        {errorResponse
          ? (
            <Col
              xs={24}
              className='error-wrapper'
            >
              <AlertComponent
                type='danger'
                message={t('pages.modeBup.send.sendMessageformComponent.notificationErrorMessage')}
              />
            </Col>
            )
          : null}
        <Col
          xs={24}
          className='form-wrapper'
        >
          <Form
            layout='vertical'
            form={form}
            onFinish={onSubmit}
          >
            <Form.Item
              name='message'
              rules={[
                {
                  required: true,
                  message: t('common.resources.bup-mode.attributes.message.validations.required')
                }
              ]}
            >
              <Input.TextArea
                size='large'
                placeholder={t('common.resources.bup-mode.attributes.message.placeholder')}
                autoSize={{ minRows: 3 }}
                id='textArea'
              />
            </Form.Item>
            <Form.Item
              name='anonymus'
              valuePropName='checked'
              onChange={onChangeCheckBox}
              initialValue={checkboxState}
            >
              <Checkbox
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center'
                }}
              >
                {t('pages.modeBup.send.sendMessageformComponent.formCheckBoxText')}
              </Checkbox>
            </Form.Item>
            <div className='button_wrapper'>
              <Form.Item shouldUpdate>
                {() => {
                  const message = form.getFieldValue('message')
                  const hasErrors = form
                    .getFieldsError()
                    .some(({ errors }) => errors.length > 0)

                  return (
                    <ButtonComponent
                      colorType='primary'
                      size='large'
                      htmlType='submit'
                      disabled={
                        !message ||
                        message.length < 4 ||
                        hasErrors
                      }
                      buttonText={t('common.resources.generic.actions.any.submit')}
                    />
                  )
                }}
              </Form.Item>
            </div>
          </Form>
        </Col>
      </Row>
    </Col>
  )
}

export default SendMessageForm
